module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/032-3ffbdb5008d8940d7affdbcd2472676c.jpg";